module.exports = __webpack_public_path__ + "media/images/mobile/abouts/2-8355605e23cb27f5dc9109e67bd155ba.jpg";